import React, { useContext, useState } from 'react';
import { Modal, Card, Table } from 'react-bootstrap';
import axiosInstance from '../utils/axios';
import StyledButton from '../../styles/StyledButton';
import StyledModal from '../../styles/StyledModal';
import StyledMovieCartWrapper from '../../styles/StyledMovieCartWrapper';
import ContextApi from '../../ContextApi';
import Alert from '@material-ui/lab/Alert';




const MovieCartModal = ({ show, hide, lastAddedMovie, showLastAddedMovie }) => {
  const [postRes, setPostRes] = useState([]);
  const { user, moviecartList, setMoviecartList} = useContext(ContextApi);

  const removeHandleClick = selectedMovieId => {
    const list = moviecartList.filter(movie => movie.id !== selectedMovieId);
    setMoviecartList(list);
  }

  const onSubmit = () => {
    let videolist = moviecartList.map(movie => movie.id).toString();

    axiosInstance({
      method: 'post',
      url: '/cart',
      data: {
        User: user.userName,
        Videolist: videolist
      }
    })
    .then(res => {
      setPostRes(res.data)
      setMoviecartList([]);
      
      })
      .catch(err => console.log(err))
  }

  const handleClose = () => {
    hide();
  }

  const removeBtnStyle = {
    color: '#582C83',
    textDecoration: 'underline',
    cursor: 'pointer'
  }

  return (
    <>

      <StyledModal show={show} size='lg' onHide={() => hide(false)}>
        <Modal.Header closeButton>
          <Modal.Title><img className='modal-img' alt='hallmark media logo' src='/images/HallmarkMedia_Logo_Plum_RGB.png' /></Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className='modal__content'>
            <div className='modal__text'>
              <StyledMovieCartWrapper>
                <Card>
                  <Card.Header>
                    <div className='header-content'>
                      <h5>Movie Request Sceener Cart</h5>                      
                      {
                        (postRes === "Movie request added successfully." ) ?
                          <Alert severity="success">Success! Your screener request has been sent. Please allow 1-2 business days for an approval.</Alert> :
                          <div>{showLastAddedMovie ? <p>Request Screener for <span style={{ fontWeight: '600' }}> {lastAddedMovie} </span> has been added to the cart. </p> : ''}</div>
                      }

                    </div>

                  </Card.Header>
                  <Card.Body>
                    <Table>
                      <thead>
                        <tr>
                          <th className="title header">Title</th>
                          <th className="image header">Poster</th>
                          <th className="desc header">Description</th>
                          <th className="delete header" >Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {moviecartList.map(movie => {
                          return (
                            <tr key={movie.id}>
                              <td className='title-content'>{movie.title}</td>
                              <td>
                                <span>
                                  <img alt={movie.title} src={movie.thumbnailUrl} />
                                </span>
                              </td>
                              <td className='synopsis-content'>{movie.titleSynopsis}</td>
                              <td>
                                <p style={removeBtnStyle} onClick={() => removeHandleClick(movie.id)}>Remove</p>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>

                    </Table>
                  </Card.Body>
                </Card>
              </StyledMovieCartWrapper>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <StyledButton onClick={hide}>Add More to Cart</StyledButton>
          { (postRes === "Movie request added successfully.")  ?
            <StyledButton onClick={handleClose}>Close</StyledButton>
            :
            <StyledButton className='purple--btn' as='a' type='submit' onClick={() => onSubmit()}>Submit</StyledButton>
          }
        </Modal.Footer>
      </StyledModal>
    </>
  );
}


export default MovieCartModal;